import { EModButtonColor } from '@ucheba/ui/components/Button/types'

export interface IBlockWithImageBoxes {
  type: string
  title?: string | null
  items: IBox[]
  button?: {
    color: keyof typeof EModButtonColor | null
  }
}

interface IBox {
  image?: string | null
  title?: string | null
  text?: string | null
  imageAlign: string
}

export enum EImageAlign {
  left = 'left',
  right = 'right',
}
